import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { openModal } from 'reducers/modalReducer';
import taskViewerService from 'services/taskViewerService';
import { TasksStatusResponseBody } from 'types/Tasks';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchBrOpenTasks = (brId: string, isEnabled?: boolean) => {
  const dispatch = useDispatch();
  const request = taskViewerService.createTasksFilterBody(false, brId, null);

  const query = useQuery<TasksStatusResponseBody, AxiosError>({
    queryKey: ['fetchBrOpenTasks', brId, request],
    queryFn: () => taskViewerService.getTasksStatusRequest(request),
    enabled: isNotNullOrUndefined(isEnabled) && isEnabled,
    gcTime: 0,
  });

  const { error, isError } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: 'Error fetching open tasks from task viewer',
              title: 'Error fetching open tasks',
              userErrorMessage: 'An error occurred when fetching open tasks',
            },
            httpError: error,
          },
        }),
      );
    }
  }, [isError, error, dispatch]);

  return query;
};
